import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ServiceForm from '../../forms/Service';

import { hideElementForNonAdminsAndNonManagers } from '../../utilities/Forms.js'

import SlidingPane from "../../components/shared/ScrollableSlidingPane";
import { request, handleRequestErrors } from '../../helpers/Requests'

class ListOfServices extends Component {
  constructor(props) {
    super(props);

    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.handleEditPanel = this.handleEditPanel.bind(this);
    this.closeEditPanel = this.closeEditPanel.bind(this);
    this.toggleCategory = this.toggleCategory.bind(this);
  }

  state = {
    services: [],
    categories: [],
    showHidden: false,
    loaded: false,
    error: null,

    activeCategory: null,

    editId: null,
    newPanelToggle: false,
    editPanelToggle: false
  };

  handleCheckbox(event) {
    let name = event.target.name;
    let value = event.target.checked;

    this.setState({[name]: value});
  }

  handleNewPanel(event) {
    this.setState({newPanelToggle: true});
    this.props.history.push('/configuration/services/new')
  }

  handleEditPanel(event) {
    let id = event.currentTarget.id;

    this.setState({
      editId: id,
      editPanelToggle: true
    });
    this.props.history.push(`/configuration/services/${id}`)
  }

  closeEditPanel() {
    this.setState({
      editPanelToggle: false,
      editId: null
    });

    this.props.history.push('/configuration/services');
    this.componentDidMount();
  }

  toggleCategory(event) {
    const category = event.currentTarget.id

    this.setState(prevState => ({
      activeCategory: category !== prevState.activeCategory ? category : null
    }))
  }

  renderWidgetRows(widgetsPerRow) {
    const rowsRequired = Math.max(this.state.categories.length / widgetsPerRow)
    let rows = []

    for(let offset = 0; offset < rowsRequired; offset++) {
      rows.push(this.renderWidgetRow(widgetsPerRow, offset))
    }

    return rows
  }

  renderWidgetRow(widgetsPerRow, offset) {
    const start = widgetsPerRow * offset
    const end = start + widgetsPerRow

    return (
      <React.Fragment key={offset}>
        {this.state.categories.slice(start, end).map(category => this.renderCategory(category))}

        {this.state.categories.slice(start, end).map(category => (
          category === this.state.activeCategory && this.renderServices(category)
        ))}
      </React.Fragment>
    )
  }

  renderCategory(category) {
    const { activeCategory } = this.state;

    const activeClass = category === activeCategory ? " active" : ""

    return (
      <React.Fragment key={category}>
        <div className={`widget service-page${activeClass}`} id={category} onClick={this.toggleCategory}><div className="center">{category}</div></div>
      </React.Fragment>
    )
  }

  renderServices(category) {
    const { showHidden } = this.state;

    const services = this.state.services.filter(service => service.category === category)
    const unhiddenServices = services.filter(service => service.hidden === false)
    const hiddenServices = services.filter(service => service.hidden === true)

    return (
      <React.Fragment key={category}>
        <div className="table big-table">
          <div className="tr heading">
            <div className="th">Name</div>
            <div className="th">Colour</div>
            <div className="th">Default Price</div>
            <div className="th">Duration</div>
            <div className="th">Category</div>
            <div className="th">Number of Staff</div>
          </div>
          {unhiddenServices.map(service => this.renderService(service))}
          {showHidden && hiddenServices.map(service => this.renderService(service, "hidden"))}
        </div>

        {this.renderHiddenServicesToggle(hiddenServices)}
      </React.Fragment>
    )
  }

  renderService(service, hidden = "") {
    const className = hidden ? "tr italics" : "tr"
    return (
      <Link to={`/configuration/services/${service.id}`} onClick={this.handleEditPanel} id={service.id} key={service.id} className={className}>
        <div className="td">{service.name}</div>
        <div className="td"><div className="color-preview" style={{backgroundColor: service.color}}/></div>
        <div className="td">{service.default_price}</div>
        <div className="td">{service.duration}</div>
        <div className="td">{service.category}</div>
        <div className="td">{service.person_ids_count}</div>
      </Link>
    )
  }

  renderHiddenServicesToggle(hiddenServices) {
    if (hiddenServices.length === 0) {
      return
    }

    return (
      <div className="toggle-hidden">
        <input type="checkbox" name="showHidden" id="hide_services" checked={this.state.showHidden} onChange={this.handleCheckbox} />
        <label htmlFor="hide_services">{this.state.showHidden === true ? "Hide" : "Show"} hidden services</label>
      </div>
    )
  }

  render() {
    const { categories, loaded, error, unauthorized } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const viewWidth = document.querySelector(".main-page").clientWidth
      const widgetWidth = 350
      const widgetsPerRow = Math.floor(viewWidth / widgetWidth)

      return (
        <div>
          <h3 className="inline-block">List of services</h3>

          <Link to={'/configuration/services/new'} onClick={this.handleNewPanel}>
            <div className={`button new-button ${hideElementForNonAdminsAndNonManagers()}`}>New Service</div>
          </Link>

          <br/>

          {categories.length === 1 ?
            this.renderServices(categories[0])
          :
            this.renderWidgetRows(widgetsPerRow)
          }

          <SlidingPane isOpen={this.state.newPanelToggle} title="New Service" width="60%"
            onRequestClose={() => {
              this.setState({ newPanelToggle: false });
              this.props.history.push('/configuration/services');
              this.componentDidMount();
            }}>
            <ServiceForm mode="create" />
          </SlidingPane>

          <SlidingPane isOpen={this.state.editPanelToggle} title="Edit Service" width="60%"
            onRequestClose={() => {
              this.closeEditPanel()
            }}>
            <ServiceForm mode="update" id={this.state.editId} closeEditPanel={this.closeEditPanel} key={this.state.key} />
          </SlidingPane>

        </div>
      );
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (state.newPanelToggle && props.id !== undefined) {
      return {
        newPanelToggle: false,
        editPanelToggle: true,
        editId: props.id
      }
    }
    else if (state.editPanelToggle && props.id === undefined) {
      return {
        editPanelToggle: false
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.history.location.pathname.endsWith("/services")) {
      return {
        newPanelToggle: false,
        editPanelToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && props.history.location.pathname.endsWith("/new")) {
      return {
        newPanelToggle: true,
        editPanelToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && props.id !== undefined) {
      return {
        newPanelToggle: false,
        editPanelToggle: true,
        editId: props.id
      }
    }
    // Handle internal linking from one UpdateService component to another
    if (state.editPanelToggle && props.id !== state.editId) {
      return {
        editId: props.id,
        key: Math.random()
      }
    }
    else {
      return null
    }
  }

  componentDidMount() {
    // deep linking
    if (this.props.location.pathname.endsWith("/new") && this.state.newPanelToggle === false) {
      this.setState({
        newPanelToggle: true
      });
    }
    else if (this.props.id !== undefined && this.state.editPanelToggle === false) {
      this.setState({
        editId: this.props.id,
        editPanelToggle: true
      });
    }

    // normal API fetching stuff
    request("GET", `/v1/a/services`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        const categories = [...new Set(data.map(service => service.category))].sort()
        this.setState({ services: data, categories: categories, loaded: true })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default withRouter(ListOfServices);
